var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountModalOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21086 10.6233C1.82034 10.2327 1.82034 9.59956 2.21086 9.20904L4.77042 6.64948L2.21086 4.08992C1.82034 3.6994 1.82034 3.06623 2.21086 2.67571C2.60139 2.28518 3.23455 2.28518 3.62508 2.67571L6.89174 5.94237C7.07928 6.12991 7.18464 6.38426 7.18464 6.64948C7.18464 6.9147 7.07928 7.16905 6.89174 7.35659L3.62508 10.6233C3.23455 11.0138 2.60139 11.0138 2.21086 10.6233ZM7.11086 10.6233C6.72034 10.2327 6.72034 9.59956 7.11086 9.20904L9.67042 6.64948L7.11086 4.08992C6.72034 3.69939 6.72034 3.06623 7.11086 2.67571C7.50139 2.28518 8.13455 2.28518 8.52508 2.67571L11.7917 5.94237C11.9793 6.12991 12.0846 6.38426 12.0846 6.64948C12.0846 6.9147 11.9793 7.16905 11.7917 7.35659L8.52508 10.6233C8.13455 11.0138 7.50139 11.0138 7.11086 10.6233Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountModalOpenIcon);
export default __webpack_public_path__ + "static/media/discountModalOpenIcon.7a30c7e1e0b26ec9148d9936f750b4e8.svg";
export { ForwardRef as ReactComponent };